import { render, staticRenderFns } from "./UserDeleteDialog.vue?vue&type=template&id=676e15c3&"
import script from "./UserDeleteDialog.vue?vue&type=script&lang=ts&"
export * from "./UserDeleteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports